<template>
  <div>
    <div class="init-icons">
      <v-icon class="init-icon no-select">
        support_agent
      </v-icon>
      <v-icon class="init-icon no-select">
        timer
      </v-icon>
    </div>
    <div v-if="retryCountDown > 0">
      <p class="init-headline mt-4">No se encontro campaña</p>
      <p class="text-font loading-text">Reintentando en {{ retryCountDown }} segundos</p> 
    </div>
    <div v-else>
      <p class="init-headline mt-4">Reintentando</p>
      <p class="text-font loading-text">Aguarde un momento</p>
    </div>
    <div>
      <v-btn  
        :disabled="retryCountDown < 1"
        class="k-orange-linear white--text" block large
        @click="$emit('cancel-auto-retry', true)">
      Cancelar
    </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    retryCountDown: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped>
@keyframes dots {
  0%, 12.5% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    text-shadow: .5em 0;
  }
  75% {
    text-shadow: .5em 0, 1em 0;
  }
}

.init-icon { 
  font-size: 65px;
  color: #2e2e44;
}

.init-headline {
  font-weight: bolder;
  font-size: 30px !important;
  text-align: center;
  margin-top: 30px;
}

.init-icons {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}

.text-font { 
  text-align: center; 
  font-size: 18px;
}

.loading-text::after {
  content: ' .';
  animation: dots 2s steps(1, end) infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/ConnectionStages/AutoRetry.vue